module.exports = __webpack_public_path__ + "static/img/pageBg3.14aae036.png";